import React from 'react';
import { RadioButton, RadioButtonGroup } from 'suomifi-ui-components';
import { FIELD, FIELD_VALUES } from './constants';
export const BasicRadioButtonGroup = ({
  i18n,
  loc,
  name,
  setFieldRef,
  formik,
  isArray,
  labels = false,
  translations = false,
  labelMode = 'visible',
  hideGroupHint = false
}) => {
  const getFieldKey = value => Object.keys(FIELD).find(k => FIELD[k] === value);
  const fieldValueObj = FIELD_VALUES[getFieldKey(name)];
  const fieldValueKeys = Object.keys(FIELD_VALUES[getFieldKey(name)]);

  const groupHintText = i18n(`${loc}.${name}_hint_text`);
  return (
    <RadioButtonGroup
      variant="large"
      labelText={i18n(`${loc}.${name}_label`)}
      name={name}
      ref={setFieldRef(name)}
      value={isArray ? formik.values?.[name][0] : formik.values?.[name]}
      groupHintText={
        groupHintText.length > 5 && !hideGroupHint ? groupHintText : ''
      }
      groupStatus={
        formik.touched[name] && formik.errors?.[name] ? 'error' : null
      }
      groupStatusText={formik.touched[name] && formik.errors?.[name]}
      labelMode={labelMode}
      onChange={async value => {
        await formik.setFieldValue(name, isArray ? [value] : value, false);
        await formik.setFieldTouched(name, true, false);
        await formik.validateField(name);
      }}
    >
      {fieldValueKeys.map(key => {
        return (
          <RadioButton
            value={fieldValueObj[key]}
            hintText={
              labels ? i18n(`${loc}.${name}_${fieldValueObj[key]}_label`) : null
            }
          >
            {translations
              ? i18n(`general.${fieldValueObj[key]}`)
              : fieldValueObj[key]}
          </RadioButton>
        );
      })}
    </RadioButtonGroup>
  );
};
